import styled from 'styled-components';

export const PanelTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: var(--color-link);
`;
